import React, { Component } from 'react';
import ReactCursorPosition from 'react-cursor-position';
import { connect } from 'react-redux';
import PercentageStars from './components/percentageStars/PercentageStars';
import { asyncFetchRatings, asyncSubmitVote, setPosition } from './state/actions';
 
import './app.scss';


const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    canVote: state.canVote,
    average: state.average,
    numberOfVotes: state.numberOfVotes,
    position: state.position
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onAsyncFetchRatings: (id, type) => dispatch(asyncFetchRatings(id, type)),
    onAsyncSubmitVote: (id, type, val) => dispatch(asyncSubmitVote(id, type, val)),
    setPosition: (val) => dispatch(setPosition(val))
  };
};


class App extends Component {
  componentDidMount() {
   this.props.onAsyncFetchRatings(this.props.id, this.props.type)
  }

  render() {
    const { canVote, average,position, numberOfVotes, onAsyncSubmitVote, type, id, setPosition, title, pageTitle } = this.props;
    return (
      <div className="betarades-voting-app">
        <PercentageStars
          type={type}
          id={id}
          title="Main Page"
          canVote={canVote}
          average={average}
          numberOfVotes={numberOfVotes}
          onAsyncSubmitVote={onAsyncSubmitVote}
          setPosition={setPosition}
          position={position}
          title={title}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js